import React, { ReactNode } from "react";

import { StyledSvg } from "../styles";
import { SvgIconComponent, SvgIconProps } from "../types";

/** The base for the few glyphs icomoon lacks, which are hand-authored inline SVGs. */
const SvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(
  ({ fontSize = "medium", color, className, children, viewBox = "0 0 24 24", ...rest }, ref) => (
    <StyledSvg
      ref={ref}
      className={className}
      $fontSize={fontSize}
      $color={color}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
    </StyledSvg>
  )
);

export default SvgIcon;

export const makeSvgIcon = (shapes: ReactNode): SvgIconComponent =>
  React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <SvgIcon ref={ref} {...props}>
      {shapes}
    </SvgIcon>
  ));
